<template>
  <div>
    <br>
    <div style="overflow: hidden">
      <!-- <el-button size="mini" type="primary" :disabled="true">{{$t('lang.particulars.modify')}}</el-button> -->
      <el-button size="mini" type="primary" @click="addn2n" v-if="Permission.indexOf(151) != -1"
        :disabled="list.n2nInfoAndN2n !== undefined">{{ $t('lang.particulars.Add') }}</el-button>
      <!-- <el-button size="mini" type="primary">修改分组</el-button> -->
      <el-select v-model="time" size="mini" class="time">
        <el-option v-for="item in setTime" :key="item.value" :label="item.name" :value="item.value"></el-option>
      </el-select>
      <el-button size="mini" type="primary" style="float: right;margin-top: 0.2rem;margin-bottom: 0.2rem;"
        @click="todevicelist">{{ $t('lang.particulars.WAD_NUMBER_RETURN') }}</el-button>
    </div>

    <div v-if="Object.keys(list).length > 1">
      <el-tabs type="border-card" :before-leave="(newTab, oldTab) => beforeLeave(newTab, oldTab)" v-model="activeName">
        <!-- 系统信息 -->
        <el-tab-pane :lazy="true" name='systemInfo'>
          <span slot="label">
            <i class="icon-zhuangtai iconcolor"></i>
            {{ $t('lang.particulars.SystemUptime') }}
          </span>
          <system-info :list="list" :SsPsShow="SsPsShow" @showDeviceDetail="showDeviceDetail"></system-info>
        </el-tab-pane>
        <!-- 基站信息 -->
        <el-tab-pane v-if="list.baseStation && !SsPsShow" name='baseInfo' :lazy="true">
          <span slot="label">
            <i class="icon-jizhanxinhao iconcolor"></i>
            {{ $t('lang.particulars.rthq_infobase') }}
          </span>
          <base-info :list="list" :SsPsShow='SsPsShow'></base-info>
        </el-tab-pane>
        <!-- 远程服务信息 -->
        <el-tab-pane v-if="list.n2nInfoAndN2n" name='n2nInfoAndN2n' :lazy="true">
          <span slot="label">
            <i class="icon-yuanchengbangjiao iconcolor"></i>
            {{ $t('lang.particulars.service') }}
          </span>
          <remote-service :list="list" :Permission="Permission" @remn2n="remn2n"></remote-service>
        </el-tab-pane>
        <!-- GPS信息 -->
        <el-tab-pane v-if="!SsPsShow" name='gps' :lazy="true">
          <span slot="label">
            <i class="icon-LC_icon_gps_line_1 iconcolor"></i>
            {{ $t('lang.particulars.GPS') }}
          </span>
          <!-- <GPS :list="list" :SsPsShow="SsPsShow" :Permission="Permission" @showDeviceDetail="showDeviceDetail"></GPS> -->
          <table v-if="!SsPsShow">
            <tr>
              <th>{{ $t('lang.particulars.long') }}</th>
              <td v-if="list.deviceLongitude">
                <!-- {{ list.deviceLongitude }} -->
                <el-input size="mini" v-model="list.deviceLongitude"></el-input>
                <span v-if="list.deviceLocType == 2" class="Gps-Information">{{ $t('lang.particulars.GPSrequire')
                }}</span>
              </td>
              <td v-else>N/A</td>
              <th>{{ $t('lang.particulars.lat') }}</th>
              <td v-if="list.deviceLatitude">
                <!-- {{ list.deviceLatitude }} -->
                <el-input size="mini" v-model="list.deviceLatitude"></el-input>
                <span v-if="list.deviceLocType == 2" class="Gps-Information">{{ $t('lang.particulars.GPSrequire')
                }}</span>
              </td>
              <td v-else>N/A</td>
            </tr>
          </table>
          <p class="Not-Features" v-else>{{ $t('lang.particulars.NotSupport') }}</p>
          <div>
            <!-- 配置高德地图 -->
            <!-- <device-long-lat
              :long="list.deviceLongitude"
              :lan="list.deviceLatitude"
              ref="map"
              v-if="this.Map==='zh-CN'&&!SsPsShow"
            /> -->
            <!-- 配置谷歌地图 -->
            <!-- <googlemap
              :long="list.deviceLongitude"
              :lan="list.deviceLatitude"
              ref="map"
              v-if="this.Map==='en-US'&&!SsPsShow"
            /> -->
            <!-- <div id="map"></div> -->
            <leafletMap ref="GPS" :list="list" @updateLatLng="updateLatLng" v-if="activeName === 'gps'"></leafletMap>
            <div style="height:30px" v-if="!SsPsShow"></div>
            <div class="Set-GPS" v-if="!SsPsShow">
              <el-button type="success" size="mini" @click="GetLonLan"
                v-if="list.deviceLocType != 2 && Permission.indexOf(194) != -1">{{ $t('lang.particulars.si_modify')
                }}</el-button>
              <el-button type="primary" size="mini" @click="ResetMap"
                v-if="list.deviceLocType != 2 && Permission.indexOf(194) != -1">{{ $t('lang.particulars.reset_type')
                }}</el-button>
            </div>
          </div>
        </el-tab-pane>
        <!-- 系统服务 -->
        <el-tab-pane :lazy="true" name="process" v-if="list.deviceSoftwareVer >= 'v1.1.3'">
          <span slot="label">
            <i class="icon-renwujincheng iconcolor"></i>
            {{ $t('lang.particulars.Processmanagement') }}
          </span>
          <process :did="deviceDid" :SN="list.deviceSn" :status="list.deviceIsconnected"
            :Permission="Permission.indexOf(196) != -1" :version="list.deviceSoftwareVer" />
        </el-tab-pane>

        <!-- 网络状态 -->
        <el-tab-pane :lazy="true" name="networkStatus">
          <span slot="label">
            <i class="icon-network iconcolor"></i>
            {{ $t('lang.particulars.networkStatus') }}
          </span>
          <network-status :smartenable="smartenable" :list="list" :SsPsShow='SsPsShow'
            @showDeviceDetail="showDeviceDetail"></network-status>
        </el-tab-pane>
        <!-- 无线wifi -->
        <el-tab-pane :lazy="true" name="wifi" v-if="isWifi">
          <span slot="label">
            <i class="icon-WIFI iconcolor"></i>
            {{ $t('lang.particulars.wirelessWifi') }}
          </span>
          <wireless-wifi ref="wifi" :did="deviceDid" :dsn="dsn"></wireless-wifi>
        </el-tab-pane>
        <!-- 下挂设备 -->
        <el-tab-pane :lazy="true" name="hangingDevice" v-if="printServer">
          <span slot="label">
            <i class="icon-huabanfuben iconcolor"></i>
            {{ $t('lang.particulars.hanging') }}
          </span>
          <hanging-device :did="deviceDid" :isConnected="list.deviceIsconnected"></hanging-device>
        </el-tab-pane>
        <!-- 终端列表 -->
        <el-tab-pane :lazy="true" name="terminalList"
          v-if="compareVersionV(list.deviceSoftwareVer, 'v2.7.230717') != -1">
          <span slot="label">
            <i class="el-icon-s-operation iconcolor"></i>
            {{ $t('lang.devicesManagement.TerminalList') }}
          </span>
          <TerminalList :did="deviceDid" ref="terminalListRef" :dsn="dsn" :time="time" :activeName="activeName">
          </TerminalList>
        </el-tab-pane>
        <el-tab-pane :lazy="true" name="webssh"
          v-if="(compareVersionV(list.deviceSoftwareVer, 'v2.9') != -1) && (Permission.indexOf(90) != -1)">
          <span slot="label">
            <i class="el-icon-monitor iconcolor"></i>
            {{ $t('lang.devicesManagement.webssh') }}
          </span>
          <Webssh :dsn="dsn" :did="deviceDid"></Webssh>
        </el-tab-pane>
        <!-- remoteWeb -->
        <el-tab-pane :lazy="true" name="remoteWeb"
          v-if="(compareVersionV(list.deviceSoftwareVer, 'v2.9') != -1) && (Permission.indexOf(287) != -1)">
          <span slot="label">
            <i class="el-icon-monitor iconcolor"></i>
            {{ $t('lang.devicesManagement.remoteWeb') }}
          </span>
          <RemoteWeb :dsn="dsn" :did="deviceDid"></RemoteWeb>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { showDeviceDetail, addDeviceN2n, delDeviceN2n, updateGps, updateDevice } from "@/api/particulars";
import { getuser_iscustomer, getuser_ctid, GetMapType } from "../../../localStorage/localStorage";
import deviceLongLat from "./deviceLongLat";
import process from "./components/process";
import googlemap from "./googlemap";
import { listConfig } from "@/api/configurationlist";
import { getPermission } from '@/cookie/cookie'
import wan2 from './components/wan2'
import wirelessWifi from './components/wirelessWifi'
import systemInfo from './components/systemInfo'
import generalInfo from './components/generalInfo'
import baseInfo from './components/baseInfo'
import remoteService from './components/remoteService'
import GPS from './components/GPS'
import networkStatus from './components/networkStatus'
import hangingDevice from './components/hangingDevice'
import leafletMap from './components/leafletMap'
import TerminalList from './components/TerminalList'
import Webssh from './components/webssh.vue'
import RemoteWeb from "./components/remoteWeb.vue";
import { coordtransform } from '@/utils/mapUtils'
import { PublicComponent } from "@/mixins/common";
import { compareVersion } from "@/utils/Date";
export default {
  name: 'Particulars',
  mixins: [PublicComponent],
  data() {
    return {
      //用户权限
      Permission: [],
      //当前用户user_iscustomer
      user_iscustomer: null,
      user_ctid: null,
      deviceId: this.$route.params.id,
      deviceDid: this.$route.params.did,
      dsn: '',
      list: {
        //设置默认值避免页面渲染后未异步获取到数据报错
        deviceStatusList: [],
        deviceSn: []
      },
      //定时刷新数据
      setTime: [
        { name: this.$t("lang.particulars.batch"), value: 99999999999 },
        { name: this.$t("lang.particulars.L5Nrefresh"), value: 5000 },
        { name: this.$t("lang.particulars.L10Nrefresh"), value: 10000 },
        { name: this.$t("lang.particulars.L20Nrefresh"), value: 20000 },
        { name: this.$t("lang.particulars.L60Nrefresh"), value: 60000 }
      ],
      time: 60000,
      //定时函数
      setIntervals: null,
      MapShow: true,
      //SS PS设备隐藏控制变量
      SsPsShow: false,
      //是否是打印服务器
      printServer: false,
      // 是否带wifi
      isWifi: false,
      //设备名称与设备地址修改
      DeviceInfo: {
        show: false,
        deviceName: '',
        id: '',
        deviceAddress: ''
      },
      activeName: 'systemInfo',
      map: null,
      smartenable: {
        gwan1: false,
        gwan2: false,
        hardware_class: "",
      }
    };
  },
  components: {
    // ParticularsMap
    deviceLongLat,
    googlemap,
    process,
    wan2,
    wirelessWifi,
    systemInfo,
    generalInfo,
    baseInfo,
    remoteService,
    GPS,
    networkStatus,
    hangingDevice,
    leafletMap,
    TerminalList,
    Webssh,
    RemoteWeb
  },
  methods: {
    //获取设备详情
    showDeviceDetail() {
      if(!this.$route.params.id){
        clearInterval(this.setIntervals);
        return
      }
      showDeviceDetail(this.$route.params.id).then(res => {
        this.$nextTick(() => {
          this.list = res.data.data;
          this.SsPsShow = this.list.deviceSn.includes('PS') || this.list.deviceSn.includes('SS')
          if (this.list.deviceSn.includes('PS') || this.list.deviceProductName ? this.list.deviceProductName.includes('PS') : false) {
            this.printServer = true
          } else {
            this.printServer = false
          }
          this.dsn = this.list.deviceSn;
          let data = [];
          if (compareVersion(this.list.deviceSoftwareVer, 'v2.7') != -1) {
            data = [
              {
                section: "network",
                config: "ciot",
                options: [
                  { option: "enable_wifi" },
                ]
              },
              {
                section: "system",
                config: "ciot",
                options: [
                  { option: "hardware_class" },
                ]
              },
            ]
          } else {
            data = [
              {
                section: "initconfig",
                config: "system",
                options: [
                  { option: "enable_wifi" },
                  { option: "hardware_class" },
                ]
              },
            ]
          }
          listConfig(this.dsn, this.deviceDid, [
            ...data,
            {
              section: "3gwan1",
              config: "network",
              options: [
                { option: "smartenable" },
              ]
            },
            {
              section: "3gwan2",
              config: "network",
              options: [
                { option: "smartenable" },
              ]
            },
          ]).then(res => {

            if (compareVersion(this.list.deviceSoftwareVer, 'v2.7') != -1) {
              if (res.data.data.mess[0].s_objects[0].options.enable_wifi === '1') {
                this.isWifi = true
              } else {
                this.isWifi = false
              }
              if (res.data.data.mess[1].s_objects.length > 0)
                this.smartenable.hardware_class = res.data.data.mess[1].s_objects[0].options.hardware_class;
              if (res.data.data.mess[2].s_objects.length > 0)
                this.smartenable.gwan1 = res.data.data.mess[2].s_objects[0].options.smartenable === '1' ? true : false;
              if (res.data.data.mess[3].s_objects.length > 0)
                this.smartenable.gwan2 = res.data.data.mess[3].s_objects[0].options.smartenable === '1' ? true : false;
            } else {
              if (res.data.data.mess[0].s_objects[0].options.enable_wifi === '1') {
                this.isWifi = true
              } else {
                this.isWifi = false
              }
              if (res.data.data.mess[0].s_objects[0].options.hardware_class)
                this.smartenable.hardware_class = res.data.data.mess[0].s_objects[0].options.hardware_class;
              if (res.data.data.mess[1].s_objects.length > 0)
                this.smartenable.gwan1 = res.data.data.mess[1].s_objects[0].options.smartenable === '1' ? true : false;
              if (res.data.data.mess[2].s_objects.length > 0)
                this.smartenable.gwan2 = res.data.data.mess[2].s_objects[0].options.smartenable === '1' ? true : false;
            }
          }).catch(err => {
            let sub = this.list.deviceModel.substring(2)[3]
            // 第四位是1表示是带wifi版本的
            this.isWifi = sub == '1' ? true : false
          })
        });
      });
    },
    //返回上一页
    todevicelist() {
      this.$router.push({ path: "/device/devicelist" });
    },
    //添加n2n确认框
    addn2n() {
      if (this.list.deviceIsconnected != 3) {
        this.$message({
          showClose: true,
          message: this.$t("lang.particulars.message1"),
          type: "error"
        });
        return;
      }
      this.$confirm(
        this.$t("lang.particulars.message2"),
        this.$t("lang.particulars.message3"),
        {
          confirmButtonText: this.$t("lang.particulars.message4"),
          cancelButtonText: this.$t("lang.particulars.message5"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          addDeviceN2n(this.deviceDid).then(res => {
            if (res.data.code === 0) {
              this.$message({
                type: "success",
                message: this.$t("lang.particulars.message6")
              });
              this.showDeviceDetail();
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message7"),
                type: "warning"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("lang.particulars.message8")
          });
        });
    },
    //删除n2n确认框
    remn2n() {
      if (this.list.deviceIsconnected != 3) {
        this.$message({
          showClose: true,
          message: this.$t("lang.particulars.message9"),
          type: "error"
        });
        return;
      }
      this.$confirm(
        this.$t("lang.particulars.message10"),
        this.$t("lang.particulars.message3"),
        {
          confirmButtonText: this.$t("lang.particulars.message4"),
          cancelButtonText: this.$t("lang.particulars.message5"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          delDeviceN2n(this.deviceDid).then(res => {
            if (res.data.code === 0) {
              this.$message({
                type: "success",
                message: this.$t("lang.particulars.message11")
              });
              // 测试完记得放开
              this.showDeviceDetail();
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message12"),
                type: "warning"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("lang.particulars.message13")
          });
        });
    },
    //获取地图组件传来的经纬度
    GetLonLan() {
      // 获取当前标记经纬度
      let latlng = this.$refs.GPS.getMarker()._latlng

      // openstreetmap获取的坐标要转换为火星坐标
      let mapType = GetMapType()
      let mypoint = null
      if (mapType === 'openStreetMap') {
        mypoint = coordtransform.wgs84togcj02(latlng.lat, latlng.lng)
      } else {
        mypoint = [latlng.lat, latlng.lng]
      }
      this.$confirm(
        `${this.$t("lang.particulars.message14")}${mypoint[1]}${this.$t(
          "lang.particulars.message17"
        )}${mypoint[0]}?`,
        this.$t("lang.particulars.message3"),
        {
          confirmButtonText: this.$t("lang.particulars.message4"),
          cancelButtonText: this.$t("lang.particulars.message5"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          updateGps(this.deviceId, mypoint[1], mypoint[0]).then(res => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message15"),
                type: "success"
              });
              this.showDeviceDetail();
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message16"),
                type: "warning"
              });
            }
          });
        })
        .catch(() => { });
    },
    //重置地图坐标
    ResetMap() {
      this.$refs.GPS.ResetLatLng();
    },
    compareVersionV(v1, v2) {
      return compareVersion(v1, v2)
    },
    //修改设备名称与设备地址
    DeviceInfoShow() {
      this.DeviceInfo.show = true
      this.DeviceInfo.deviceAddress = this.list.deviceAddress
      this.DeviceInfo.deviceName = this.list.deviceName ? this.list.deviceName : ''
      this.DeviceInfo.id = this.list.deviceId
    },
    // 离开标签页
    beforeLeave(targetTab, currentTab) {
      // 清除wifi标签页的计时器
      if (currentTab === 'wifi') {
        this.$refs[currentTab].clearTimer()
      }
    },
    UpDeviceNameAndAddress() {
      updateDevice(this.DeviceInfo.id, this.DeviceInfo.deviceName, this.DeviceInfo.deviceAddress)
        .then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t("lang.particulars.message15"),
              type: "success"
            });
            this.DeviceInfo.show = false
            this.showDeviceDetail();
          } else {
            this.$message({
              showClose: true,
              message: this.$t("lang.particulars.message16"),
              type: "warning"
            });
          }
        })
    },
    updateLatLng(lat, lng) {
      this.list.deviceLatitude = lat
      this.list.deviceLongitude = lng
    },
    getData() {
      //获取当前用户的user_iscustomer
      this.deviceDid = this.$route.params.did
      this.user_iscustomer = getuser_iscustomer();
      this.user_ctid = getuser_ctid();
      //页面进入加载一次数据
      this.showDeviceDetail();
      //页面进入默认10秒刷新数据
      this.setIntervals = setInterval(() => {
        this.showDeviceDetail();
      }, this.time);
      //获取权限
      this.Permission = getPermission();
    }
  },
  watch: {
    //监听定时刷新下拉框
    time(a, b) {
      window.clearInterval(this.setIntervals);
      this.setIntervals = setInterval(() => {
        this.showDeviceDetail();
      }, a);
    },
    deviceDid: {
      immediate: true,
      handler() {
        this.activeName = 'systemInfo';
        this.list.baseStation = false;
        this.SsPsShow = false
        this.list.n2nInfoAndN2n = false;
        this.list.deviceSoftwareVer = "";
        this.isWifi = false;
        this.printServer = false;

      }
    }
  },
  //页面销毁前删除定时器
  beforeDestroy() {
    window.clearInterval(this.setIntervals);
    if (this.$refs['terminalListRef']) this.$refs['terminalListRef'].clearTimer()
  },
  deactivated() {
    window.clearInterval(this.setIntervals);
    if (this.$refs['terminalListRef']) this.$refs['terminalListRef'].clearTimer()
  },
  activated() {
    this.getData();
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
.title {
  margin-top: 0.3rem;
  width: 100%;
  height: 0.8rem;
  font-size: 0.35rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.2rem;
}

table {
  border: 1px solid #ebeef5;
  width: 100%;
  background-color: #ffffff;
}

tr {
  border: 1px solid #ebeef5;
  height: 0.8rem;
}

tr:hover {
  background-color: #f5f7fa;
}

th {
  color: #909399;
  border: 1px solid #ebeef5;
  font-size: 0.3rem;
  font-weight: 500;
  width: 19%;
  padding-left: 10px;
}

td {
  border: 1px solid #ebeef5;
  width: 30%;
  padding-left: 10px;
  font-size: 0.25rem;
}

.time {
  margin-bottom: 0.2rem;
  margin-left: 0.2rem;
  width: 2.5rem;
}

.iconcolor {
  color: #0dc21c;
}

.Set-GPS {
  float: right;
  overflow: hidden;
}

.Gps-Information {
  color: red;
  margin-left: 10px;
}

.Not-Features {
  text-align: center;
  margin: 10px;
  font-size: 15px;
  color: #f56c6c;
  font-weight: 700;
}
</style>
